import React, { memo, useState } from 'react';

import { AudioPlayer } from '@eluve/audio-player';
import {
  Button,
  Icon,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Stack,
  Text,
} from '@eluve/components';

import { useSegmentAudioContext } from './SegmentAudioContextStore';

export interface SegmentAudioControlsProps {
  audioUrl: string;
}

const SegmentAudioControlsComponent: React.FC<SegmentAudioControlsProps> = ({
  audioUrl,
}) => {
  const { store, audioPlayerHandle } = useSegmentAudioContext();
  const [jumpDuration, setJumpDuration] = useState(10);

  return (
    <Stack gap={6} fullWidth={false} direction="horizontal">
      <AudioPlayer
        audioUrl={audioUrl}
        ref={audioPlayerHandle}
        onTimeUpdate={(timestamp) => {
          store.send({ type: 'updateTimestamp', timestamp });
        }}
      />
      <Stack fullWidth={false} gap={2} direction="horizontal">
        <Text>Jump:</Text>
        <Select
          value={jumpDuration.toString()}
          onValueChange={(value) => setJumpDuration(Number(value))}
        >
          <SelectTrigger className="w-fit">
            <SelectValue placeholder="Jump" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={'1'}>1</SelectItem>
            <SelectItem value={'3'}>3</SelectItem>
            <SelectItem value={'5'}>5</SelectItem>
            <SelectItem value={'10'}>10</SelectItem>
            <SelectItem value={'20'}>20</SelectItem>
            <SelectItem value={'30'}>30</SelectItem>
          </SelectContent>
        </Select>
        <Button onClick={() => audioPlayerHandle.current?.rewind(jumpDuration)}>
          <Icon name="Rewind" size="auto" />
          {jumpDuration.toString()}
        </Button>

        <Button
          onClick={() => audioPlayerHandle.current?.fastForward(jumpDuration)}
        >
          <Icon name="FastForward" size="auto" />
          {jumpDuration.toString()}
        </Button>
      </Stack>
      <Stack fullWidth={false} gap={2} direction="horizontal">
        <Text>Playback speed:</Text>
        <Select
          defaultValue="1"
          onValueChange={(value) =>
            audioPlayerHandle.current?.setPlaybackSpeed(Number(value))
          }
        >
          <SelectTrigger className="w-fit">
            <SelectValue placeholder="Speed" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={'0.5'}>0.5x</SelectItem>
            <SelectItem value={'0.75'}>0.75x</SelectItem>
            <SelectItem value={'1'}>1x</SelectItem>
            <SelectItem value={'1.25'}>1.25x</SelectItem>
            <SelectItem value={'1.5'}>1.5x</SelectItem>
            <SelectItem value={'2'}>2x</SelectItem>
          </SelectContent>
        </Select>
      </Stack>
    </Stack>
  );
};

export const SegmentAudioControls = memo(SegmentAudioControlsComponent);
